import BaseAPI from "./base/base-api";

class ProviderAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "provider";
}

export default new ProviderAPI();
